export default __webpack_public_path__ + "static/media/kaapi-3.d3f634c6.jpg";